import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"
import { IconRemove } from "../icons"


export default function SelectedFiltersCustom({ totalProducts }) {

    const { filters, removeAll } = useProductFilters()

    return (
        (filters.length > 0 && (
            <>
                <div className="results-count">
                        Total: <strong>{totalProducts}</strong> products
                </div>
                <div class="summary flex flex-wrap align-items-center">
                    <button class="animation" type="button" onClick={() => removeAll()}>Clear All</button>
                    {filters.map(filter => (
                        <button 
                            type="button" 
                            onClick={() => filter.remove()}
                            className="flex align-items-center animation" 
                            arialLabel={`Remove filter ${filter.name}`}>
                            <span>{filter.name}</span>:&nbsp;<strong>{filter.value}</strong>
                            <IconRemove />
                        </button>
                    ))}
                </div>
            </>
        ))
    )
}
